import { useSmartEvent } from '../../core/hooks';
import { useRunned } from '../Keyboard';
import { useContext } from '.';

interface PluginSDK {
    showed: boolean,
    handleClose: () => void,
    handleAccept: () => void,
}


const ESC = 27;
const ENTER = 13;

export const useKeyboard = ({ showed, handleClose, handleAccept }: PluginSDK): void => {

    const { id } = useContext();
    const runned = useRunned(id());

    const handler = (e: KeyboardEvent) => {
        const k = e.keyCode;

        switch(k){
            case ESC: {
                runned(() => {
                    handleClose();
                    e.preventDefault();
                });
                return;
            }
            case ENTER: {
                runned(() => {
                    handleClose();
                    handleAccept();
                    e.preventDefault();
                });
                return;
            }
        }
    };

    useSmartEvent<KeyboardEvent>({
        handler,
        on: (h) => window.addEventListener('keydown', h),
        off: (h) => window.removeEventListener('keydown', h),
        predicate: () => showed,
        signal: [handleClose, handleAccept],
    });

}
